import { StatDisplayCount } from 'features/drilldown/components/stats/StatDisplayCount'
import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import { GenericPanelData } from 'features/drilldown/types'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'

import { useMetricCalculation } from './metricsCalculations'
import {
  DEFAILT_AVAILABLE_METRIC_CONFIGS,
  DrilldownMetricConfig,
} from './MetricsPanelConfig'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`

const NoMetricsText = styled.div`
  color: #888;
  text-align: center;
  padding: 20px;
`

export interface MetricsPanelData extends GenericPanelData {
  activeMetrics: ReadonlyArray<string>
}

export const DEFAULT_METRICS_PANEL_DATA: MetricsPanelData = {
  title: 'Metrics',
  panelDataSchemaVersion: 1,
  isPinned: true,
  activeMetrics: [],
}

export const MetricsPanel: FC = () => {
  return <MetricsPanelView />
}

const MetricView: FC<{
  metricConfig: DrilldownMetricConfig
}> = ({ metricConfig }) => {
  const { value, isLoading } = useMetricCalculation(metricConfig)

  return (
    <StatDisplayCount
      title={metricConfig.title}
      count={value}
      isLoading={isLoading}
      numDecimals={metricConfig.numDecimals}
    />
  )
}

export const MetricsPanelView: FC = () => {
  const {
    panelData: { activeMetrics },
  } = useVersionAwareDrilldownPanelData<MetricsPanelData>()

  const enabledMetricConfigs: readonly DrilldownMetricConfig[] = useMemo(
    () =>
      DEFAILT_AVAILABLE_METRIC_CONFIGS.filter((config) =>
        activeMetrics.includes(config.metricType)
      ),
    [activeMetrics]
  )

  return (
    <Container>
      {enabledMetricConfigs.map((metricConfig) => (
        <MetricView key={metricConfig.metricType} metricConfig={metricConfig} />
      ))}
      {enabledMetricConfigs.length === 0 && (
        <NoMetricsText>No Metrics Selected</NoMetricsText>
      )}
    </Container>
  )
}
